class Marquee {

    constructor(chatContainer, adjustTop) {
        this.chatContainer = chatContainer;
        this.adjustTop = adjustTop;
        this.MIN_ITEMS = 3;
        this.MAX_ITEMS = 5;
        this.ITEMS = [];
        this.MARQUEE = null;
        this.RUNNING = false;
        this.VISIBLE = false;
    }

    reset() {
        this.VISIBLE = false;
        this.RUNNING = false;
        this.ITEMS = [];
        this.hide();
    }

    addItem(item) {
        const elm = document.createElement('div');
        elm.className = 'item';
        if (item !== undefined) {
            elm.appendChild(item);
        } else {
            elm.appendChild(txt);
        }

        this.enqueue(elm);

        if (this.VISIBLE === false && this.ITEMS.length >= this.MIN_ITEMS) {
            this.show();
        }
    }

    enqueue(item) {
        this.ITEMS.push(item);

        if (this.ITEMS.length > this.MAX_ITEMS) {
            /* Remove first item as we append the new item */
            this.ITEMS.shift();
        }
    }

    run() {
        this.RUNNING = true;
        if (this.ITEMS.length > 0) {
            const item = this.ITEMS.shift();
            this.getMarquee().appendChild(item);

            this.animationEvents(item, 'AnimationEnd', function () {
                this.getMarquee().innerHTML = '';
                this.addItem(item.childNodes[0]);
                this.run();
            });

            this.animationEvents(item, 'AnimationStart', function () {
            });
        }
    }

    show() {
        this.VISIBLE = true;
        this.getMarquee().style.display = 'block';

        this.getMarquee().classList.add('slideDown');
        this.getMarquee().classList.remove('slideUp');

        if (this.RUNNING === false) {
            this.run();
        }
        this.adjustTop();
    }

    hide() {

        this.getMarquee().classList.add('slideUp');
        this.getMarquee().classList.remove('slideDown');
        this.getMarquee().style.display = 'none';
        this.adjustTop();
    }

    getMarquee() {
        if (this.MARQUEE === null) {
            this.MARQUEE = document.querySelector(this.chatContainer + ' .marquee');
        }

        return this.MARQUEE;
    }

    animationEvents(element, type, callback) {
        const pfx = ["webkit", "moz", "MS", "o", ""];
        for (let p = 0; p < pfx.length; p++) {
            if (!pfx[p]) type = type.toLowerCase();
            element.addEventListener(pfx[p] + type, callback, false);
        }
    }
}